export const gameRankingReport = {
  rankingReport: "Ranking Report",
  exportReport: "Export Report",
  player: "PLAYER",
  today: "TODAY",
  week: "WEEK",
  win: "win",
  loss: "loss",
  month: "MONTH",
  game: "GAME",
};
